import React from "react";
import { useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CircularProgress } from "@mui/material";
import {
  fDummyFunction,
  GridDataColumn,
} from "../../../Component/Common/ReuseableComponent/Action";
import { CmpButton } from "../../../Component/Common/ToolBox/ToolBox.js";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";

import {
  fCal_MSPGPPerc,
  fCal_TAXRSP,
  fCal_GPPerc,
  fCal_SellPr1,
} from "../GRNNormalAction";
import { fAlertToast } from "./../../../Utility/Utilitys";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky.jsx";
const GCMSPUpdate = ({
  xOpen = false,
  fCloseDetailModal,
  GridDataMSPUpdateColumns,
  GridDataMSPUpdateRows = [],
  xTitle = "Account Detail",
  xLabelVocType = "",
  xLabelVocName = "",
  xLabelVocNo = "",
  setGridDataMSPUpdateRows,
  MSPUpdateSaveBtn,
  fMSP_SAVE,
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const [sGridEditing, setGridEditing] = useState(false);

  const fEditMSP = (params) => {
    if (Number(params?.value) < 0) {
      // Show an alert or handle the error as needed
      fAlertToast("FAILED", "MSP cannot be lesser than zero");

      return params.row;
    }
    const itemList = GridDataMSPUpdateRows?.map((x) => {
      if (x?.id === params.row?.id) {
        x.MSP = Number(params.value);
        x.MSPGPPerc = fCal_MSPGPPerc(params.value, params.row.CostPr);
        // x.MSPGPPerc =
        //   Number(params.value) == 0
        //     ? 0
        //     : Number(
        //         (
        //           ((Number(params.value) - Number(params.row.CostPr)) /
        //             Number(params.value)) *
        //           100
        //         ).toFixed(2)
        //       );
        return x;
      } else {
        return x;
      }
    });
    setGridDataMSPUpdateRows(itemList);
    params.row.MSP = Number(params.value);

    return params.row;
  };
  const fEditTSROH = (params) => {
    if (Number(params?.value) < 0) {
      // Show an alert or handle the error as needed
      fAlertToast("FAILED", "OH cannot be lesser than zero");

      return params.row;
    }
    const itemList = GridDataMSPUpdateRows?.map((x) => {
      if (x?.id === params.row?.id) {
        x.TSROH = Number(params.value);
        return x;
      } else {
        return x;
      }
    });
    setGridDataMSPUpdateRows(itemList);
    params.row.TSROH = Number(params.value);

    return params.row;
  };

  const fEditRSP = (params) => {
    if (Number(params?.value) < 0) {
      // Show an alert or handle the error as needed
      fAlertToast("FAILED", "RSP cannot be lesser than zero");

      return params.row;
    }
    const itemList = GridDataMSPUpdateRows?.map((x) => {
      if (x?.id === params.row?.id) {
        x.SellPr1 = Number(params.value);

        x.TAXRSP = fCal_TAXRSP(params.value, params.row.TaxPerc);
        x.GPPerc = fCal_GPPerc(params.value, params.row.CostPr);
        // x.TAXRSP =
        //   Number(params.value) +
        //   (Number(params.value) * Number(params.row.TaxPerc)) / 100;
        // x.GPPerc =
        //   Number(params.value) == 0
        //     ? 0
        //     : Number(
        //         (
        //           ((Number(params.value) - Number(params.row.CostPr)) /
        //             Number(params.value)) *
        //           100
        //         ).toFixed(2)
        //       );
        return x;
      } else {
        return x;
      }
    });
    setGridDataMSPUpdateRows(itemList);
    params.row.SellPr1 = Number(params.value);

    return params.row;
  };

  const fEdit_VAT_RSP = (params) => {
    if (Number(params?.value) < 0) {
      // Show an alert or handle the error as needed
      fAlertToast("FAILED", "TAXRSP cannot be lesser than zero");

      return params.row;
    }
    const itemList = GridDataMSPUpdateRows?.map((x) => {
      if (x?.id === params.row?.id) {
        x.TAXRSP = Number(params.value);
        x.SellPr1 = fCal_SellPr1(params.row.TaxPerc, params.value);
        x.GPPerc = fCal_GPPerc(params.row.SellPr1, params.row.CostPr);
        // x.SellPr1 =
        //   Number(params.row.TaxPerc) + 100 == 0
        //     ? 0
        //     : (Number(params.value) * 100) / (Number(params.row.TaxPerc) + 100);
        // x.GPPerc =
        //   Number(params.row.SellPr1) == 0
        //     ? 0
        //     : Number(
        //         (
        //           ((Number(params.row.SellPr1) - Number(params.row.CostPr)) /
        //             Number(params.row.SellPr1)) *
        //           100
        //         ).toFixed(2)
        //       );
        return x;
      } else {
        return x;
      }
    });
    setGridDataMSPUpdateRows(itemList);
    params.row.TAXRSP = Number(params.value);

    return params.row;
  };

  //vatRSP-TAXRSP  iRSP-SellPr1  iCost-CostPr iTaxPerc-TaxPerc
  //   VatRsp = iRSP + ((iRSP * iTaxPerc) / 100);
  //org---TAXRSP=SellPr1 +(SellPr1 *TaxPerc ) / 100)

  // GP.% = ((iRSP - iCost) / iRSP) * 100;
  //Org---GPPerc =((SellPr1-CostPr)/SellPr1)* 100

  // RSP = (iVatRsp * 100) / (iTaxPerc + 100);
  //org SellPr1=(TAXRSP * 100) /(TaxPerc + 100)

  const columns = GridDataMSPUpdateColumns.map((x) => {
    if (x.field === "MSP") {
      return {
        ...x,
        valueSetter: fEditMSP,
        editable: true,
        type: "number",
      };
    } else if (x.field === "TSROH") {
      return {
        ...x,
        valueSetter: fEditTSROH,
        editable: true,
        type: "number",
      };
    } else if (x.field === "SellPr1") {
      return {
        ...x,
        valueSetter: fEditRSP,
        editable: true,
        type: "number",
      };
    } else if (x.field === "TAXRSP") {
      return {
        ...x,
        valueSetter: fEdit_VAT_RSP,
        editable: true,
        type: "number",
      };
    } else {
      return x;
    }
  });
  return (
    <Modal
      open={xOpen}
      onClose={fCloseDetailModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-gc-search"
      >
        
        <GCTitleSticky title={xTitle} onClose={fCloseDetailModal} />
         
        <div className="p-2">
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="mt-2 justify-content-between"
          >
            <Grid item xs={3} sm={1} md={1} className="gnr-item-search-label ">
              VocType
            </Grid>
            <Grid
              item
              xs={8}
              sm={11}
              md={11}
              className="gnr-item-search-label "
            >
              {xLabelVocType}
            </Grid>
            <Grid item xs={3} sm={1} md={1} className="gnr-item-search-label ">
              VocName
            </Grid>
            <Grid
              item
              xs={8}
              sm={11}
              md={11}
              className="gnr-item-search-label "
            >
              {xLabelVocName}
            </Grid>
            <Grid item xs={3} sm={1} md={1} className="gnr-item-search-label ">
              VocNo
            </Grid>
            <Grid
              item
              xs={8}
              sm={11}
              md={11}
              className="gnr-item-search-label "
            >
              {xLabelVocNo}
            </Grid>
            {/* <Grid item xs={3}>
              kasdasd
            </Grid> */}
          </Grid>
          <Grid container spacing={1} className="search-item ">
            <Grid item xs={12} className=" height-table-scroll" component="div">
              <div
                style={{
                  height: vMediaQuery ? "38vh" : "48vh",
                  width: "100%",
                }}
                id="table-main-grid-3"
                className="search-grid-table mt-2"
              >
                <Box style={{ height: "100%", width: "100%" }}>
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    rows={GridDataMSPUpdateRows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    hideFooter={GridDataMSPUpdateRows.length < 100}
                    onCellEditStart={() => setGridEditing(true)}
                    onCellEditStop={() => setGridEditing(false)}
                    onCellEditCommit={() => setGridEditing(false)}
                    components={{
                      Toolbar: GridToolbar,
                    }}
                  />
                </Box>
              </div>
            </Grid>
          </Grid>
          <div className="py-2">
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12 }}
              justifyContent={"end"}
              // className="justify-content-end"
            >
              <Grid
                item
                xs={"auto"}
                sm={"auto"}
                md={"auto"}
                className="GCSearchBtn-label "
              >
                <CmpButton
                  xbtnName="Save"
                  xOnClick={(e) => {
                    fMSP_SAVE();
                  }}
                  xVariant="contained"
                  xDisabled={MSPUpdateSaveBtn || sGridEditing}
                  xSize="small"
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default GCMSPUpdate;
